import React from "react";
import DataTable from "react-data-table-component";
import { Spinner } from "react-bootstrap";
import { format } from "date-fns";

const Passhistory = ({ historydata, historyloading }) => {
  const columns = [
    {
      name: "Pass ID",
      selector: (row) => row?.pass_id || "-",
      wrap: true,
    },
    {
      name: "Route",
      selector: (row) => {
        const name = row?.route?.name;
        const number = row?.route?.route_number;
        return name && number ? `${name} (${number})` : name || "-";
      },
      wrap: true,
      grow: 2,
    },
    {
      name: "Shift",
      selector: (row) => {
        if (!row.shift) return "-";
        const startTime = row.shift.start_time;
        const endTime = row.shift.end_time;

        try {
          const start = new Date(`1970-01-01T${startTime}`);
          const end = new Date(`1970-01-01T${endTime}`);
          return `${row.shift.name} [${format(start, "h:mm a")} - ${format(end, "h:mm a")}]`;
        } catch {
          return row.shift.name || "-";
        }
      },
      wrap: true,
    },
    {
      name: "Issue Date",
      selector: (row) => {
        try {
          return row?.start_date
            ? format(new Date(row.start_date), "d MMM yyyy")
            : "-";
        } catch {
          return "-";
        }
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Cancel Date",
      selector: (row) => {
        try {
          return row?.pass_cancel_date
            ? format(new Date(row.pass_cancel_date), "d MMM yyyy")
            : "-";
        } catch {
          return "-";
        }
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row.status || "-",
      width: "130px",
      cell: (row) => (
        <span
          className={`badge text-bg-${
            row?.status?.toLowerCase() === "active"
              ? "success-soft"
              : "danger-soft"
          }`}
        >
          {row.status}
        </span>
      ),
    },
  ];

  return (
    <div>
      <div className="card">
        <div className="p-2">
          <span className="text-primary fw-semibold">Pass History</span>
        </div>
        <div className="card-body p-0">
          <DataTable
            columns={columns}
            data={historydata}
            responsive
            noDataComponent={<div className="p-2">There are no records found.</div>}
            sortIcon={<div className="data-table-sorter" />}
            progressPending={historyloading}
            progressComponent={
              <div className="text-center my-4">
                <Spinner animation="border" variant="primary" />
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Passhistory;
